import type { IconData } from '@stacksjs/iconify-core'

export const cm4x3: IconData = {
  "body": "<path fill=\"#007a5e\" d=\"M0 0h213.3v480H0z\"/><path fill=\"#ce1126\" d=\"M213.3 0h213.4v480H213.3z\"/><path fill=\"#fcd116\" d=\"M426.7 0H640v480H426.7z\"/><g fill=\"#fcd116\" transform=\"translate(320 240)scale(7.1111)\"><g id=\"SVG7njaB7bZ\"><path id=\"SVG3NvIFRSJ\" d=\"M0-8L-2.5-.4L1.3.9z\"/><use width=\"100%\" height=\"100%\" href=\"#SVG3NvIFRSJ\" transform=\"scale(-1 1)\"/></g><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(72)\"/><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(144)\"/><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(-144)\"/><use width=\"100%\" height=\"100%\" href=\"#SVG7njaB7bZ\" transform=\"rotate(-72)\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cm4x3
